export default "__VITE_ASSET__6febd255__"